var ServicesWithTerms;
(function (ServicesWithTerms) {
    // banks
    ServicesWithTerms["savings"] = "savings";
    ServicesWithTerms["debitCards"] = "debitCards";
    ServicesWithTerms["creditCards"] = "creditCards";
    ServicesWithTerms["credits"] = "credits";
    ServicesWithTerms["mortgage"] = "mortgage";
    ServicesWithTerms["leasing"] = "leasing";
    ServicesWithTerms["businessRko"] = "businessRko";
    ServicesWithTerms["businessDeposit"] = "businessDeposit";
    ServicesWithTerms["businessCredits"] = "businessCredits";
    ServicesWithTerms["acquiring"] = "acquiring";
    ServicesWithTerms["biznesRegistration"] = "biznesRegistration";
    ServicesWithTerms["bankGuarantees"] = "bankGuarantees";
    ServicesWithTerms["bukhgalteriyaDlyaBiznesa"] = "bukhgalteriyaDlyaBiznesa";
    // insuranceCompany
    ServicesWithTerms["homeInsurance"] = "homeInsurance";
    ServicesWithTerms["criticalIllness"] = "criticalIllness";
    ServicesWithTerms["strakhovaniyeOtUkusaKleshcha"] = "strakhovaniyeOtUkusaKleshcha";
    ServicesWithTerms["healthInsurance"] = "healthInsurance";
    // educationalOrganization
    ServicesWithTerms["educationalType"] = "educationalType";
    ServicesWithTerms["biznesNaMarketpleysakh"] = "biznesNaMarketpleysakh";
    // mfo
    ServicesWithTerms["microcredits"] = "microcredits";
    // other (не услуги/теги отзывов)
    ServicesWithTerms["biznesVed"] = "biznesVed";
    ServicesWithTerms["broker"] = "broker";
    ServicesWithTerms["accumulativeDeposit"] = "accumulativeDeposit";
    ServicesWithTerms["bankrotstvo"] = "bankrotstvo";
    ServicesWithTerms["zarplatnyjProekt"] = "zarplatnyjProekt";
    ServicesWithTerms["bukmekery"] = "bukmekery";
})(ServicesWithTerms || (ServicesWithTerms = {}));

export { ServicesWithTerms };
//# sourceMappingURL=index.js.map
